export const BOOKING_C2_ENDPOINT_PREFIX = '/BookingsService/api/V1/bookingBusinessesc2';
export const API_ACTIONS = {
    LIST_SERVICES: 'services',
    GET_STAFF_AVAILABILITY: 'getStaffAvailability',
    GET_BUSINESS_LOGO: 'businessLogo',
    GET_APPOINTMENT: 'appointments',
    UPDATE_BOOKING_URL: 'bookingUrl',
    CUSTOM_QUESTIONS: 'customQuestions',
};
